import React from 'react'
import alert from '../images/questionmark.svg';
import { useEffect } from 'react';
import { useState } from 'react';
import { GetPaymentUrlAndUserInfo } from '../services/Apiservices';
import { Loader } from '../helper/Loader';
import { toast} from 'react-toastify';
export default function Basescreen() {

  const [userLink,SetUrlLink]=useState();
  const [Pending,SetPending]=useState(true);

console.log(process.env.REACT_APP_AUTHENTICATION_TOKEN)
  const HandleredirectPayment=(e)=>{
    e.preventDefault();
    localStorage.clear();
    window.open(userLink,'_self');

  }

const HandleRedirectPayment=()=>{

  if(!localStorage.getItem('user_data')){
    toast.error("Unauthorized Access")
    setTimeout(()=>{
      localStorage.clear();
      window.open(process.env.REACT_APP_PAYME_REDIRECT,'_self');  
    },[2000])
  }
else{
  const data={
    'user_data':localStorage.getItem('user_data')
  }

GetPaymentUrlAndUserInfo(data).then((response)=>{
               if(response?.data?.is_emandate==false){
                localStorage.clear();
                window.open(response?.data?.link,'_self');
        
               }
               else{
                SetPending(false)
                SetUrlLink(response?.data?.link);
               }
}).catch((error)=>{
  if(error?.response?.status_code==401){
    toast.error("Unauthorized Access")
  }
  else{
  toast.error("Something Went Wrong")
}
setTimeout(()=>{
  localStorage.clear();
  window.open(process.env.REACT_APP_PAYME_REDIRECT,'_self');  
},[2000])
})    
    
}
}

  useEffect(() => {
HandleRedirectPayment();
  }, [])
  

  const Handleredirect=(e)=>{
    e.preventDefault();

    window.open(process.env.REACT_APP_PAYME_REDIRECT,'_self');

  }
  return (
    <>
    {Pending?<Loader/>:
    <div className='popup'>
    
    <div className='actualpopup'>

<div className='alertmessages'>
    <img src={alert}></img>
</div>
<div className='textheading'>Double Payment Alert!</div>

     <div className='paymentmessage'>
        <div className='laguagetext'>Your automatic payment has already been sent to the bank. If you make a payment here, you might be charged twice. Are you sure you want to proceed?
</div>
        <hr></hr>
        <div className='laguagetext'>आपका ऑटोमेटिक पेमेंट पहले ही बैंक को भेज दिया गया है। यदि आप यहां से भी पेमेंट करते हैं, तो आपके खाते में दो बार पैसे कट सकते हैं। क्या आप सुनिश्चित हैं कि आगे बढ़ना चाहते हैं?</div>

     </div>


        <div className='yesornobutton'>
                <button className='cancelbtn' onClick={Handleredirect}>Cancel</button>
         
               <button className='yesbtn' onClick={HandleredirectPayment} >Yes</button>
        </div>

    </div>

</div>

  }
  </>
  )
}
